{
    "ourTeam": {
        "keyMembers": "Nyckelpersoner",
        "tabName": "Vårt team"
    },
    "releaseNotes": {
        "accordianHeading": "Släpp me@eon V<version>",
        "accordianMyHelpHeading": "Släpp MyHelp (me@eon) V<version>",
        "accordianMyHelpNewHeading": "Släpp MyHelp V<version>",
        "faq": "FAQ",
        "tabName": "Utgivningshistorik",
        "tipsAndTricks": "Tips and Trix",
        "whatsNew": "Nyheter"
    },
    "featureRoadmap": {
        "tabName": "Funktioner & färdplan"
    }
}